<template>
  <div>
    <div class="row">
      <div class="col-lg-12" style="padding-top: 60px">
        <div class="row">
          <div class="col-lg">
            <card class="card-eprf">
              <div class="row">
                <div class="col-lg-3">
                  <p style="color: #5e99ff; font-size: 24px; font-weight: 300">
                    COLLECTION SCHEDULE
                  </p>
                </div>
              </div>
              <div style="display: flex">
                <div
                  style="
                    margin: 3px 10px 5px 5px;
                    width: 15px;
                    height: 15px;
                    background-color: #368dcc;
                  "
                ></div>
                <span style="color: #aaaaaa">Waste Collection</span>
              </div>
              <!-- style="color: #000000 !important" -->
              <div class="row">
                <div class="col-lg" style="width: 1200px">
                  <full-calendar
                    :events="demoEvents"
                    @dayClick="dayClick"
                    @eventClick="eventClick"
                    
                    @changeMonth="handleMonthChange"
                    :firstDay="1"
                  >
                  </full-calendar>
                </div>
              </div>
            </card>
          </div>
        </div>
        <modal :show.sync="modals.noti" class="modal-eprf" centered>
          <b-card
            class="card"
            style="background-color: #f5f6fa; box-shadow: none"
            border-variant="primary"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <template #header>
              <div class="row">
                <div class="col-lg">
                  <h4 class="mb-0">{{ tajuk }}</h4>
                </div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i
                      style="
                        transform: translate(-50%, -50%);
                        color: white;
                        font-weight: 900;
                        font-size: 12px;
                      "
                      class="tim-icons icon-simple-remove"
                      @click="modals.noti = false"
                    ></i>
                  </base-button>
                </div>
              </div>
            </template>

            <div class="row">
              <div class="col-lg">
                <el-table
                  :data="tableData"
                  :header-cell-style="{
                    border: 'transparent',
                    'font-size': '14px',
                    'font-weight': '400',
                    color: '#707070',
                  }"
                  :cell-style="{ fontColor: '#707070' }"
                  :row-style="tableRowClassName"
                  style="color: #707070"
                >
                  <el-table-column width="50">
                    <div slot-scope="scope">
                      <base-button
                        class="btn-icon btn-round btn-sm"
                        style="color: #ffffff; font-size: 13px"
                        >{{ scope.$index + 1 }}</base-button
                      >
                    </div>
                  </el-table-column>
                  <el-table-column label="Job No" prop="jobno">
                  </el-table-column>
                  <el-table-column label="Customer" prop="customer">
                  </el-table-column>
                  <!-- <el-table-column label="Time" prop="time"> -->
                  <!-- <div slot-scope="{ row }">
                    <el-time-select
                      :picker-options="{
                        start: '00:00',
                        end: '23:00',
                      }"
                      v-model="row.time"
                      placeholder="Select time"
                    ></el-time-select>
                  </div> -->
                  <!-- </el-table-column> -->
                  <el-table-column label="Date" prop="start">
                    <!-- <div slot-scope="{ row }">
                    <el-date-picker
                      v-model="row.end"
                      placeholder="Select date"
                    ></el-date-picker>
                  </div> -->
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <br />
            <!-- <div class="row">
            <div class="col-lg text-right">
              <base-button @click="submit()">Save Changes</base-button>
            </div>
          </div> -->
          </b-card></modal
        >
      </div>
    </div>
  </div>
</template>

<script>
import Calendar from "src/components/Calendar/Calendar.vue";
import FullCalendar from "vue-fullcalendar";
import moment from "moment";
import { Modal } from "src/components";
import { BCard } from "bootstrap-vue";
import { Table, TableColumn, DatePicker, TimeSelect } from "element-ui";
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
  name: "VendorSchedule",

  components: {
    Calendar,
    FullCalendar,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [TimeSelect.name]: TimeSelect,
    [DatePicker.name]: DatePicker,
    BCard,
  },

  data() {
    return {
      // calendarOptions: {
      //   plugins: [dayGridPlugin, interactionPlugin],
      //   eventRender: this.changeEventColorOnRender, // Apply color during render
      // },
      demoEvents: [
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   // cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   // cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office",
        //   start: "2024-01-15",
        //   end: "2024-01-15",
        //   time: "09:00",
        //   // cssClass: ["delay"],
        // },
        // {
        //   title: "Sunny Out of Office qwertyuiop",
        //   start: "2024-01-14",
        //   end: "2024-01-14",
        //   time: "09:00",
        //   cssClass: ["delay"],
        // },
        // {
        //   title: "hewwo",
        //   start: "2024-01-20",
        //   end: "2024-01-20",
        //   time: "13:00",
        //   cssClass: ["onschedule"],
        // },
      ],
      modals: {
        noti: false,
      },
      tajuk: "",
      tableData: [],
    };
  },
  mounted() {},
  created() {
    this.year = moment().format("YYYY");
    this.month = moment().format("M");
    // this.getDatas();
  },
  methods: {
   
    handleMonthChange(start, end, current) {
      console.log("hhuhuhuhu");
      this.year = moment(current, "YYYY-MM-DD").format("YYYY");
      this.month = moment(current, "YYYY-MM-DD").format("M");

      this.getDatas();
    },
    dayClick(day, jsEvent) {},
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      } else {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      }
    },
    eventClick(event, jsEvent, pos) {
      this.tajuk =
        "JOB INFORMATION - " +
        moment(event.end, "YYYY-MM-DD").format("DD MMMM YYYY");

      this.tableData = [
        {
          customer: event.customer,
          jobno: event.jobno,
          start: event.start,
          end: event.end,
          time: "08:00",
        },
      ];
      this.title = event.title;
      this.tarikh = moment(event.start, "YYYY-MM-DD").format("DD MMMM YYYY");
      this.modals.noti = true;
    },
    getDatas() {
      this.demoEvents = [];

      this.$http
        .get(
          ":10001/api/v1/outgoing/schedule?year=" +
            this.year +
            "&month=" +
            this.month
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let titlee;
              let titlee1;

              let timee;
              let oo = [];
              for (var j = 0; j < response[i].data.length; j++) {
                titlee1 = response[i].data[j].reference_number;
                timee = moment(response[i].date).format("hh:mm A");
                titlee = titlee1;

                let obj = {
                backgroundColor: '#ff0000',
                  title: titlee,
                  start: moment(response[i].date).format("YYYY-MM-DD"),
                  end: moment(response[i].date).format("YYYY-MM-DD"),
                  time: timee,
                  cssClass: response[i].data[j].status == 1 ? ["status1"] : ["status4"],
                  jobno: response[i].data[j].reference_number,
                  customer: response[i].data[j].company_name,
                  
                  
                };

                oo.push(obj);
              }
              // console.log(titlee1)
              // console.log(timee)
              if (titlee1 !== null && timee !== null) {
                for (var k = 0; k < oo.length; k++) {
                  this.demoEvents.push(oo[k]);
                }
              }
            }

            this.demoEvents.map(event => ({
        // ...event,
        color: event.color === '#ff0000' ? '#0000ff' : '#ff0000',
      }));

            console.log(this.demoEvents)
          }
          // this.load = false;
        });
    },
  },

  computed: {},
};
</script>
<style>
.comp-full-calendar {
  min-width: none !important;
  max-width: none !important;
  width: 100%;
}

.header-center {
  text-align: right !important;
}

.header-right {
  display: none;
}
.day-cell .day-number {
  color: #A5A5A5;
  height: 101px;
}
.day-cell .not-cur-month {
  color: #A5A5A5 !important;
  opacity: 0.5;
}

.full-calendar-body .dates .week-row .day-cell:last-child,
.full-calendar-body .dates .week-row .day-cell:nth-child(6) {
  background-color: rgb(236, 234, 234) !important;
}

.delay {
  background: rgb(255, 153, 0) !important;
  color: #ffffff !important;
}

.status1 {
  background: #0AAB00 !important;
  color: #ffffff !important;
}

.status2 {
  background: #0AAB00 !important;
  color: #ffffff !important;
}

.status3 {
  background: #0AAB00 !important;
  color: #ffffff !important;
}

.status4 {
  background: orange !important;
  color: #ffffff !important;
}
</style>
